import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClassRow } from "../viewUtils";
import styles from "./ClassItemViewCell.module.scss";

export const PercentageCell = memo(function PercentageCell({
    row,
}: CellContext<ViewTableFeatures, ClassRow, unknown>) {
    const item = row.original;
    // Mirror TransactionsCell: rows with children always show their subtree
    // percentage (their direct percentage can be 0 while descendants hold the
    // transactions), leaves show their own.
    const hasChildren = (item.children?.length ?? 0) > 0;
    const percentage = hasChildren ? item.groupPercentage : item.percentage;

    if (Number.isNaN(percentage)) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <span
                className={classNames(styles.label, {
                    [styles.zero]: percentage === 0,
                })}
            >
                {percentage.toFixed(1)}%
            </span>
        </ViewTableCell>
    );
});
